module.exports = __webpack_public_path__ + "img/sany.10316dd3.png";